"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var constants_1 = __importDefault(require("../../../config/constants"));
var styles_1 = require("../styles");
var RaffleWinnings = function (_a) {
    var winningResults = _a.winningResults, theme = _a.theme;
    var classes = (0, styles_1.styles)(theme)();
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(core_1.Typography, { variant: "h2", className: classes.sectionTitle }, t('numberChecker.results')),
        react_1.default.createElement("div", { style: { marginTop: '24px' } },
            react_1.default.createElement("div", { className: classes.resultContainer },
                react_1.default.createElement(core_1.Typography, { variant: "h3", className: classes.drawDate }, t('numberChecker.yourTickets')),
                react_1.default.createElement("div", { style: { marginTop: '24px', width: '100%' } }, winningResults.map(function (result) {
                    var ticket = result.playersTicket
                        .toString()
                        .padStart(constants_1.default.PADDED_ZEROS_LENGTH ? constants_1.default.PADDED_ZEROS_LENGTH : 6, '0');
                    return (react_1.default.createElement(core_1.Grid, { xl: 12, key: ticket, className: classes.playersTicket },
                        react_1.default.createElement(core_1.Typography, { variant: "body1", component: "p", className: classes.ticketText }, ticket),
                        react_1.default.createElement(core_1.Typography, { variant: "body1", component: "p", className: (0, classnames_1.default)([classes.ticketText]) }, "".concat(t('numberChecker.amountWon'), " "),
                            react_1.default.createElement("b", { className: result.winningAmount > 0 ? classes.winningAmount : '' }, result.winningAmountHumanReadable))));
                }))))));
};
exports.default = RaffleWinnings;
//# sourceMappingURL=RaffleWinnings.js.map